import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { forwardRef } from 'react';
import { CustomItem as Custom } from '@atlaskit/menu';
import { baseSideNavItemStyle, overrideStyleFunction } from '../../common/styles';
import { useShouldNestedElementRender } from '../NestableNavigationContent/context';

/**
 * Used to support any custom items needed by products alongside the Header and Footer patterns.
 * Specific implementation of headers and footers are provided in the examples folder.
 */
var CustomItem = /*#__PURE__*/forwardRef( // Type needed on props to extract types with extract react types.
function (_ref, ref) {
  var cssFn = _ref.cssFn,
      rest = _objectWithoutProperties(_ref, ["cssFn"]);

  var _useShouldNestedEleme = useShouldNestedElementRender(),
      shouldRender = _useShouldNestedEleme.shouldRender;

  if (!shouldRender) {
    return null;
  }

  var cssOverride = overrideStyleFunction(baseSideNavItemStyle, cssFn);
  return /*#__PURE__*/React.createElement(Custom, _extends({
    ref: ref,
    cssFn: cssOverride
  }, rest));
} // Dirty hack to get generics working with forward ref [2/2]
);
export default CustomItem;